import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox } from 'element-plus';
import { UserFilled, Lock } from '@element-plus/icons-vue';
import AuthService from '@/services/AuthService';

@Component(
{
    components:
    {
        UserFilled
    }
})

export default class PasswordReset extends Vue 
{
    private environmentVersion = '';
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;

    public async mounted()
    {
        this.environmentVersion = process.env.VUE_APP_VERSION;
        window.addEventListener('resize', this.onWindowResize);
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }
}
